// src/components/SlideShow.tsx
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import { ReactElement } from 'react';
// import kompetanse from '../assets/images/Kompetansehuset.jpg';
import { CompanyPage } from './CompanyPage';
import { companyPagesData } from '../utils/companies';
import { buildFloorsFromCompanies } from '../utils/floors';
import { FloorDirectoryOverlay } from './FloorDirectoryOverlay';

// const bgImages = [
//   kompetanse,
//   'https://dfstudio-d420.kxcdn.com/wordpress/wp-content/uploads/2019/06/digital_camera_photo-1080x675.jpg',
//   'https://gratisography.com/wp-content/uploads/2024/11/gratisography-augmented-reality-800x525.jpg',
// ];

export const SlideShow = () => {
  const floors = buildFloorsFromCompanies(companyPagesData);

  const pages: ReactElement[] = [
    // Keep the single directory slide (optional). You can remove this if you only want the overlay.
    // <FloorPage
    //   key="floor-directory"
    //   bgImages={bgImages}
    //   logo={kplogo}
    //   floors={floors}
    // />,
    ...companyPagesData
      .filter((c) => c.showInSlide)
      .map((data) => <CompanyPage key={data.name} {...data} />),
  ];

  return (
    <>
      <FloorDirectoryOverlay floors={floors} /> {/* renders once, fixed */}
      <Slide
        arrows={false}
        indicators={false}
        duration={30000}
        pauseOnHover={false}
        canSwipe={false}
      >
        {pages}
      </Slide>
    </>
  );
};
